import { Button, Select, Switch, Input, Tooltip } from "antd";
import {
  DownloadIcon,
  FilterIcon,
  SearchIcon,
  SelectArrow,
  TickIcon,
} from "../../../../../../atoms/CustomIcons";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../../config/hooks";
import { removeMaterialListingData } from "../../../../ducks/actions";

interface FilterProps {
  setFilters: React.Dispatch<
    React.SetStateAction<{
      category: undefined | string[];
      status: undefined | string;
      search_text?: string;
    }>
  >;
  filters: {
    category: undefined | string[];
    status: undefined | string;
    search_text?: string;
  };
  archived: boolean;
  isArchived: React.Dispatch<React.SetStateAction<boolean>>;
  setTabValue: (val: string) => void;
}

interface CategoryType {
  label: string;
  value: string;
}

export default function Filters(props: FilterProps) {
  const { setFilters, filters, archived, isArchived, setTabValue } = props;
  const dispatch = useAppDispatch();
  const [showFilters, setShowFilters] = useState(false);
  const [categoryDropDown, setCategoryDropDown] = useState<CategoryType[]>([]);
  const tagItems = useAppSelector((state) => state?.tags?.tagData);

  const onChange = (checked: boolean) => {
    dispatch(removeMaterialListingData());
    isArchived(checked);
    if (checked) {
      setFilters((prev) => ({
        ...prev,
        status: "archived",
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        status: undefined,
      }));
    }
  };

  const clearFilters = () => {
    setFilters({
      category: undefined,
      status: undefined,
    });
    isArchived(false);
  };

  useEffect(() => {
    if (tagItems?.data && tagItems?.data?.length > 0) {
      const dummyArray: CategoryType[] = [];
      tagItems?.data?.map((item: { name: string; id: string; color: string }) =>
        dummyArray.push({
          label: item?.name,
          value: item?.id,
        })
      );
      setCategoryDropDown(dummyArray);
    } else {
      setCategoryDropDown([]);
    }
  }, [tagItems]);

  return (
    <div className="filtersWrapper">
      <div className="filtersTop">
        <div className="filterTabsButton">
          <Button onClick={() => setTabValue("materials")} type="primary">
            Materials
          </Button>
          <Button onClick={() => setTabValue("equipment")} type="text">
            Equipment
          </Button>
        </div>
        <div className="filterSearch">
          <Input
            prefix={<SearchIcon />}
            placeholder="Search materials"
            value={filters?.search_text}
            allowClear
            onChange={(e) =>
              setFilters((prev) => ({
                ...prev,
                search_text: e.target.value,
              }))
            }
          />
        </div>
        <div className="filterToggle">
          <Button
            icon={<FilterIcon />}
            className={`outlined-btn ${showFilters && "show_filters"} ${
              archived && "archived"
            }`}
            onClick={() => setShowFilters(!showFilters)}
          >
            Filters{" "}
            <div className="filter_icon">
              <SelectArrow />
            </div>
          </Button>
        </div>
        <div className="filterDownload">
          <Button icon={<DownloadIcon />} />
        </div>
      </div>
      {showFilters && (
        <div className="filtersBottom">
          <div className="btmLeft">
            <div className="filterBox">
              <Tooltip title="Category" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  onChange={(value) =>
                    setFilters((prev) => ({ ...prev, category: value }))
                  }
                  value={filters?.category}
                  placeholder="Category"
                  options={categoryDropDown}
                  mode="multiple"
                  maxTagCount={1}
                />
              </Tooltip>
            </div>

            <div className="filterBox">
              <div className="switchBox">
                <Switch onChange={onChange} checked={archived} />
                {archived ? "Hide archived" : "Show archived"}
              </div>
            </div>
          </div>

          <div className="btmRight">
            <div className="btmRight">
              <Button
                className="outlined-btn"
                onClick={clearFilters}
                disabled={
                  !filters.category && !filters.status && !filters.search_text
                }
              >
                Clear filters
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
